export const generateUniqId = (): string => {
    let dateTime = new Date().getTime();
    const uuidResult = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (value) => {
        const randomValue = (dateTime + Math.random() * 16) % 16 | 0;
        dateTime = Math.floor(dateTime / 16);
        return (value == 'x' ? randomValue : (randomValue & 0x3) | 0x8).toString(16);
    });
    return uuidResult;
};
